import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useT } from "@/i18n/LangProvider";
import SEO from "@/components/site/SEO";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Problems from "@/components/site/Problems";
import Offer from "@/components/site/Offer";
import Geo from "@/components/site/Geo";
import Process from "@/components/site/Process";
import Portfolio from "@/components/site/Portfolio";
import BeforeAfter from "@/components/site/BeforeAfter";
import Testimonials from "@/components/site/Testimonials";
import Fit from "@/components/site/Fit";
import Faq from "@/components/site/Faq";
import FinalCta from "@/components/site/FinalCta";
import Footer from "@/components/site/Footer";

const KNOWN_LANGS = ["de", "pt", "en"];

export default function Home() {
  const { lang: urlLang } = useParams();
  const { setLang, lang } = useT();

  // Sync language from URL param (e.g. /pt, /en)
  useEffect(() => {
    if (urlLang && KNOWN_LANGS.includes(urlLang) && urlLang !== lang) {
      setLang(urlLang);
    }
  }, [urlLang, lang, setLang]);

  useEffect(() => {
    // Reveal-on-scroll observer
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main data-testid="home-page" className="min-h-screen text-[color:var(--white)]">
      <SEO page="home" />
      <Navbar />
      <Hero />
      <Ticker />
      <Portfolio />
      <Problems />
      <Offer />
      <Geo />
      <Process />
      <BeforeAfter />
      <Testimonials />
      <Fit />
      <Faq />
      <FinalCta />
      <Footer />
    </main>
  );
}
